import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../../Logo';
import { DeckAmbience } from '../SlideFrame';
import { TalabAskBar } from '../TalabWindow';
const EASE = [0.23, 1, 0.32, 1] as const;
export function SlideCover({
  active
}: {
  active: boolean;
}) {
  return <div className="relative w-full h-full overflow-hidden bg-white" data-id="element-1932" data-mp="fpjby3u34iz6">
      <DeckAmbience data-id="element-1933" data-mp="frm2qq32ag4y" />

      {/* Concentric rings anchor the lockup without adding decorative filler. */}
      <div className="absolute inset-0 flex items-center justify-center" aria-hidden="true" data-id="element-1934" data-mp="3e99g6jzuoffk">
        {[300, 440, 580].map((size, index) => <motion.div key={size} className="absolute rounded-full border border-primary-indigo/[0.07]" style={{
        width: size,
        height: size,
        marginTop: -70
      }} initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.9,
        ease: EASE,
        delay: 0.1 + index * 0.08
      }} data-id="element-1935" data-mp="3o533myf3xtc4" data-mpi={index} />)}
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full px-16 text-center" data-id="element-1936" data-mp="1j7efv4zh0b3l">
        <h1 className="sr-only" data-id="element-1937" data-mp="1eafogu76yi93">Talab — Your AI Storefront. The Future Marketplace.</h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        filter: 'blur(6px)'
      }} animate={active ? {
        opacity: 1,
        scale: 1,
        filter: 'blur(0px)'
      } : {
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.7,
        ease: EASE
      }} data-id="element-1938" data-mp="1a6zs7yz1ajwx">
          <Logo size="lg" className="scale-[1.6]" data-id="element-1939" data-mp="vhtsm9waaroi" />
        </motion.div>

        <motion.p className="mt-20 font-display font-bold text-[38px] leading-tight tracking-tight text-dark-navy" initial={{
        opacity: 0,
        y: 18
      }} animate={active ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 18
      }} transition={{
        duration: 0.6,
        ease: EASE,
        delay: 0.25
      }} data-id="element-1940" data-mp="qja7gbpiljx7">
          Your AI Storefront.{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-indigo to-ai-purple" data-id="element-1941" data-mp="cksmglqzuliz">
            The Future Marketplace.
          </span>
        </motion.p>

        <motion.p className="mt-4 text-[15px] text-slate-500" initial={{
        opacity: 0,
        y: 14
      }} animate={active ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 14
      }} transition={{
        duration: 0.6,
        ease: EASE,
        delay: 0.38
      }} data-id="element-1942" data-mp="7w9imjrygi90">
          From browsing and filters to simply asking.
        </motion.p>

        <motion.div className="w-[520px] mt-10" initial={{
        opacity: 0,
        y: 22
      }} animate={active ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 22
      }} transition={{
        duration: 0.65,
        ease: EASE,
        delay: 0.5
      }} data-id="element-1943" data-mp="lp8vsf49m0de">
          <TalabAskBar caret focused data-id="element-1944" data-mp="gv4ofur37qbs" />
        </motion.div>
      </div>
    </div>;
}